import { w as A } from "../withTheme-zx3wTAWo.es.js";
import r from "react";
import e from "prop-types";
import { s as o, S as x, O as T } from "../index-CeW5cjt7.es.js";
import u from "lodash";
import P from "memoize-one";
import { D as Q } from "../DotBounceLoading-BQiSmZUw.es.js";
import { I as C } from "../Icon-BuIPTPJn.es.js";
import { I as b } from "../Interpolate-cCQtVKA2.es.js";
import { w as I } from "../utils-C0l876fA.es.js";
import '../index11.css';const v = "#87080f", D = "Placeholders-compere-module__error___96-4F", M = "Placeholders-compere-module__iconError___SdzcY", w = "Placeholders-compere-module__noResults___eOcKF", N = "Placeholders-compere-module__loading___N09NU", B = "Placeholders-compere-module__errorAction___L9Y2T", k = {
  iconColor: v,
  error: D,
  iconError: M,
  noResults: w,
  loading: N,
  errorAction: B
}, F = "#87080f", $ = "Placeholders-default-module__error___Brq6q", K = "Placeholders-default-module__iconError___JwKvF", U = "Placeholders-default-module__noResults___j98cK", j = "Placeholders-default-module__loading___BLhk8", Y = "Placeholders-default-module__errorAction___qFf0r", p = {
  iconColor: F,
  error: $,
  iconError: K,
  noResults: U,
  loading: j,
  errorAction: Y
}, _ = {
  compere: k,
  default: p
}, S = (n) => {
  const t = _[n.theme] || p;
  return /* @__PURE__ */ r.createElement("div", { "aria-live": "polite", role: "status" }, n.alternateText.noResults.trim().replace(/\n */g, `
 `).split(/\n \n /g).map((s, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ r.createElement("p", { className: t.noResults, key: i }, /* @__PURE__ */ r.createElement(
      b,
      {
        template: s.replace(/{{([^}]+)}}/g, "{$1}"),
        values: {
          term: /* @__PURE__ */ r.createElement("b", null, n.term),
          noResultsAction: /* @__PURE__ */ r.createElement("a", { href: n.actionLink }, n.alternateText.noResultsAction)
        }
      }
    ))
  )));
};
S.propTypes = {
  term: e.string.isRequired,
  alternateText: e.objectOf(e.string).isRequired,
  actionLink: e.string.isRequired,
  theme: e.oneOf(["compere", "default"]).isRequired
};
const f = (n) => {
  const t = _[n.theme] || p;
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      className: t.loading,
      "aria-live": "polite",
      role: "status",
      "aria-label": "Loading"
    },
    /* @__PURE__ */ r.createElement(Q, { width: 4 })
  );
};
f.propTypes = {
  theme: e.oneOf(["compere", "default"]).isRequired
};
const R = (n) => {
  const t = _[n.theme] || p;
  return /* @__PURE__ */ r.createElement("div", { className: t.error, "aria-live": "assertive", role: "alert" }, /* @__PURE__ */ r.createElement(
    C,
    {
      className: t.iconError,
      color: t.iconColor,
      size: 20,
      name: "warning"
    }
  ), /* @__PURE__ */ r.createElement("span", null, /* @__PURE__ */ r.createElement(
    b,
    {
      template: n.alternateText.error.replace(
        /{{([^}]+)}}/g,
        "{$1}"
      ),
      values: {
        errorLeader: /* @__PURE__ */ r.createElement("b", null, n.alternateText.errorLeader),
        errorAction: n.alternateText.errorAction
      }
    }
  )));
};
R.propTypes = {
  alternateText: e.objectOf(e.string).isRequired,
  theme: e.oneOf(["compere", "default"]).isRequired
};
const g = 250, L = 500;
class h extends r.Component {
  state = {
    textInput: ""
  };
  componentDidUpdate(t) {
    t.onQuery !== this.props.onQuery && (this.debouncedOnQuery = u.debounce(
      this.props.onQuery,
      g
    ), this.throttledOnQuery = u.throttle(
      this.props.onQuery,
      L
    ));
  }
  getFilterOptions = P((t, s, i) => i ? t.filter((l) => i(l, s)) : t);
  debouncedOnQuery = u.debounce(this.props.onQuery, g);
  throttledOnQuery = u.throttle(this.props.onQuery, L);
  handleSelect = (t) => {
    const s = {};
    this.props.options.concat(this.props.selected).forEach((l) => {
      s[l.value] = l.label;
    });
    const i = t.map((l) => ({
      label: s[l],
      value: l
    }));
    this.props.onSelect(i);
  };
  handleTextInput = (t) => {
    const { value: s } = t.target;
    this.setState({ textInput: s }), s.length >= 2 && !this.props.queryOnEnterKey ? this.debouncedOnQuery(s, null) : this.props.onReset();
  };
  handleScrollBottom = () => {
    this.props.cursor && this.props.status === o.COMPLETE && this.throttledOnQuery(this.state.textInput, this.props.cursor);
  };
  handleRetryAll = () => {
    this.props.onQuery(this.state.textInput, null);
  };
  handleRetryMore = () => {
    this.throttledOnQuery.cancel(), this.throttledOnQuery(this.state.textInput, this.props.cursor);
  };
  handleEnter = () => {
    this.props.onQuery(this.state.textInput, null);
  };
  render() {
    const { t } = this.props, s = {
      focusPlaceholder: t("Search..."),
      noResults: t("Could not find any results for {{term}}."),
      // Text for an optional "contact" link or other side-effect to find more results.
      noResultsAction: null,
      errorLeader: t("Oops!"),
      errorAction: t("Please retry."),
      error: t("{{errorLeader}} Something went wrong. {{errorAction}}")
    }, l = {
      ...{
        single: {
          ...s,
          selectedFocusPlaceholder: t("Search...")
        },
        multiple: {
          ...s,
          selectedFocusPlaceholder: t("Add Another...")
        }
      }[this.props.multiple ? "multiple" : "single"],
      ...this.props.alternateText
    };
    let a = null, d = null;
    const c = {
      alternateText: l,
      theme: this.props.theme
    }, O = this.getFilterOptions(
      this.props.options,
      this.state.textInput,
      this.props.filterOption
    );
    this.props.status === o.COMPLETE && !O.length && (a = /* @__PURE__ */ r.createElement(
      S,
      {
        ...c,
        term: this.props.latestQuery,
        actionLink: this.props.noResultsActionLink
      }
    )), this.props.status === o.ALL_LOADING && (a = /* @__PURE__ */ r.createElement(f, { ...c })), this.props.status === o.MORE_LOADING && (d = /* @__PURE__ */ r.createElement(f, { ...c })), this.props.status === o.ALL_ERROR && (a = /* @__PURE__ */ r.createElement(
      R,
      {
        ...c,
        onClick: this.handleRetryAll
      }
    )), this.props.status === o.MORE_ERROR && (d = /* @__PURE__ */ r.createElement(
      R,
      {
        ...c,
        onClick: this.handleRetryMore
      }
    ));
    const q = this.props.selected.map((m) => m.label).join(", ");
    return /* @__PURE__ */ r.createElement(
      x,
      {
        ...this.props,
        ...this.state,
        options: this.props.status === o.READY ? this.props.selected : O,
        selected: this.props.selected.map((m) => m.value),
        selectText: q,
        onSelect: this.handleSelect,
        onTextInput: this.handleTextInput,
        searchable: !0,
        inputSearchIcon: !0,
        alternateText: l,
        onScrollBottom: this.handleScrollBottom,
        alternateBody: a,
        alternateFooter: d,
        chipOpts: this.props.selected,
        onEnter: this.props.queryOnEnterKey ? this.handleEnter : void 0,
        status: this.props.status
      }
    );
  }
}
h.displayName = "MassiveSearchableSelect.Component";
h.propTypes = {
  // Don't know what happens to categories in a massively-searchable select,
  // yet.
  /** @ignore */
  onQuery: e.func.isRequired,
  /** Function called with new `selected` options when they change due to user interaction. */
  onSelect: e.func.isRequired,
  /** Called when the expanded state should be changed to given boolean value */
  onExpand: e.func,
  /** The selectable options. See Option object below for details on possible keys/values. */
  options: e.arrayOf(T).isRequired,
  /** The array of currently selected option _objects_. */
  selected: e.arrayOf(T).isRequired,
  /** @ignore */
  status: e.oneOf(Object.values(o)).isRequired,
  /** An object for passing in text translations. See below for the full object of strings with defaults. */
  alternateText: e.objectOf(e.string),
  /** @ignore  */
  cursor: e.oneOfType([e.string, e.number]),
  /** @ignore */
  latestQuery: e.string.isRequired,
  /** Set to true to allow selection of multiple options. */
  multiple: e.bool,
  /** @ignore */
  onReset: e.func,
  /** The path in an action link shown when no results are returned from a search. Not present by default. */
  noResultsActionLink: e.string,
  /** A function to filter out the displayed options, based on the matching textInput or any other logic. This function is called for each option on render, and only renders the options for which this function returns true. */
  filterOption: e.func,
  /** Set to true to search when enter key is pressed rather than on input changes. */
  queryOnEnterKey: e.bool,
  /** @ignore */
  t: e.func.isRequired,
  /** 'compere' or 'default' styling. */
  theme: e.oneOf(["compere", "default"]).isRequired,
  /** When true, text '(required)' will appear next to the label */
  required: e.bool,
  /** The label text shown above the Select.<br/>
   * <b>Required if `props.ariaLabelledBy` is not defined</b> */
  label: e.string,
  /** When true, select will be displayed with 'dark' mode. */
  dark: e.bool,
  /** If true and multiple is true, chips will be displayed below the select for each selected option. */
  showChips: e.bool,
  /** If true and multiple is true, chips will be displayed below the select for each selected option. */
  disabled: e.bool,
  /** Set to true to make dropdowns show all options without scrolling. */
  dropdownShowAll: e.bool,
  /** Set to true to highlight the select box when one of the dropdown options is selected. */
  highlightWhenOptionSelected: e.bool,
  /** the 'id' property to be passed to the select */
  id: e.string,
  /** HTML id of corresponding description for accessibility */
  ariaDescribedBy: e.string,
  /** HTML id of corresponding label for accessibility.<br/>
   * <b>Required if `props.label` is not defined.</b> */
  ariaLabelledBy: e.string,
  /** When this is specified, the text input renders with a red outline and displays this string in an error footer to prompt the user to correct the input. */
  error: e.string
};
h.defaultProps = {
  alternateText: {},
  cursor: null,
  multiple: !1,
  onReset: () => null,
  noResultsActionLink: "",
  filterOption: null,
  queryOnEnterKey: !1,
  required: !1,
  onExpand: () => null,
  label: void 0,
  dark: !1,
  showChips: !1,
  disabled: !1,
  dropdownShowAll: !1,
  highlightWhenOptionSelected: !1,
  id: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  error: null
};
const G = A(I(h));
class E extends r.Component {
  state = {
    options: [],
    status: o.READY,
    cursor: null,
    latestQuery: ""
  };
  componentWillUnmount() {
    this.unmounted = !0;
  }
  isRequestStale(t) {
    return t !== this.currentRequest || this.state.status === o.READY ? !0 : !!this.unmounted;
  }
  handleQuery = (t, s) => {
    this.setState({
      status: s ? o.MORE_LOADING : o.ALL_LOADING,
      latestQuery: t
    });
    const i = this.props.fetch(t, s);
    this.currentRequest = i, i.then((l) => {
      this.isRequestStale(i) || this.setState((a) => ({
        status: o.COMPLETE,
        options: s ? [...a.options, ...l.options] : l.options,
        cursor: l.cursor
      }));
    }).catch(() => {
      this.isRequestStale(i) || this.setState({
        status: s ? o.MORE_ERROR : o.ALL_ERROR
      });
    });
  };
  handleReset = () => {
    this.setState({ status: o.READY });
  };
  render() {
    const t = {
      onQuery: this.handleQuery,
      onReset: this.handleReset,
      ...this.state
    };
    return this.props.children(t);
  }
}
E.displayName = "MassiveSearchableSelect.Container";
E.propTypes = {
  fetch: e.func.isRequired,
  children: e.func.isRequired
};
const y = ({ fetch: n, ...t }) => /* @__PURE__ */ r.createElement(E, { fetch: n }, (s) => /* @__PURE__ */ r.createElement(G, { ...s, ...t }));
y.status = o;
y.propTypes = {
  /** Promise-generating function to asynchronously fetch new results. */
  fetch: e.func.isRequired
};
const se = A(y);
export {
  se as default
};
